import Api from 'libs/api';

class RestaurantsApi extends Api {
  constructor() {
    super('admin/restaurants');
  }
}

export default RestaurantsApi;
